module.exports = __webpack_public_path__ + "img/bespoke123_07.7d5d1841.jpg";